// extracted by mini-css-extract-plugin
export default {"cta-block__title-img":"CtaBlock_cta-block__title-img__Ce-4p"};